import { IconButton, MenuItem, withStyles, Menu } from '@material-ui/core';
import Tooltip from '../common/StyledToolTip';
import {
  HelpOutline as HelpOutlinedIcon,
  StarBorder as StarOutlined,
} from '@material-ui/icons';
import { Suspense, useState } from 'react';
import { RMAXLogger } from '../../services/LoggerService/RMAXLogger';
import { compose } from 'recompose';
import { withAppConfig } from '../../appConfigContext';
import { AppLoading } from '../../loaders/loaders';
const AboutRMAXDialog = React.lazy(() => import("../header/Dialogs/AboutRMAXDialog"));

const styles = (theme) => ({
  muiIconContainer: {
    borderLeft: `1px solid ${theme.headerBorderColor}`
  },
  headerIconStyles: {
    height: '32px',
    boxSizing: 'border-box',
    cursor: 'pointer',
    '&:hover': {
      color: theme.HeaderSelectedText
    }
  },
  muiIconButtonStyle: {
    padding: '9px 15px'
  },
  helpMenu: {
    background: theme.ModalBGColor,
    borderRadius: '0px 0px 4px 4px',
    marginTop: '8px',
    overflow: 'visible'
  },
  helpMenuItem: {
    fontSize: '12px',
    lineHeight: '14px',
    color: theme.TextColor,
    padding: '4px 18px 4px 4px',
    "&:hover": {
      background: theme.customMultiSelectColor,
    },
  },
  starIconColor: {
    color: theme.starIconColor
  }
});

const HelpMenu = ({
  closeMenu,
  configJSON,
  classes,
}) => {
  const [helpanchorEl, setHelpMenuAnchor] = useState(null);
  const [showAboutRmaxDialog, setShowAboutRmaxDialog] = useState(false);

  const { RMAXWhatsNewURL, RMAXHelpURL } = configJSON;
  const handleHelpIconClick = (event) => {
    setHelpMenuAnchor(event.currentTarget);
  };

  const handleHelpIconClose = () => {
    setHelpMenuAnchor(null);
  };

  const onHelpMenuItemClicked = (url, pageTitle) => {
    window.open(url, '_blank');
    handleHelpIconClose();
    RMAXLogger.info('HelpMenu', { pageTitle });
  };

  const openAboutRmaxDialog = () => {
    setShowAboutRmaxDialog(true);
  }

  const closeAboutRmaxDialog = () => {
    setShowAboutRmaxDialog(false);
    closeMenu();
  }

  return (
    <>
      <div
        className={`${classes.muiIconContainer} ${classes.headerIconStyles}`}
        data-automationid="help-menu">
        <IconButton
          color="inherit"
          className={classes.muiIconButtonStyle}
          onClick={handleHelpIconClick}>
          <Tooltip title="Help">
            <HelpOutlinedIcon />
          </Tooltip>
        </IconButton>
        <Menu
          getContentAnchorEl={null}
          disableAutoFocusItem
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          open={Boolean(helpanchorEl)}
          anchorEl={helpanchorEl}
          onClose={handleHelpIconClose}
          MenuListProps={{ disablePadding: true }}
          classes={{
            paper: classes.helpMenu
          }}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
          {RMAXHelpURL && (
            <MenuItem
              className={classes.helpMenuItem}
              onClick={() => onHelpMenuItemClicked(RMAXHelpURL, 'Help')}
              data-automationid="help">
              <IconButton
                disableRipple
                color="primary"
                >
                <HelpOutlinedIcon />
              </IconButton>
              Help
            </MenuItem>
          )}

          {RMAXWhatsNewURL && (
            <MenuItem
              className={classes.helpMenuItem}
              onClick={() => onHelpMenuItemClicked(RMAXWhatsNewURL, "What's New")}
              data-automationid="whats-new">
              <IconButton
                disableRipple
                className={classes.starIconColor}>
                <StarOutlined />
              </IconButton>
              What's New
            </MenuItem>
          )}

          <MenuItem
            className={classes.helpMenuItem}
            onClick={() => {
              openAboutRmaxDialog();
              handleHelpIconClose();
            }}
            data-automationid="about-rmax">
            <IconButton disableRipple>
              <img src="../../images/AboutRMAX.svg" />
            </IconButton>
            About RouteMAX
          </MenuItem>
        </Menu>
      </div>
      {showAboutRmaxDialog && (
        <Suspense fallback={<AppLoading />}>
          <AboutRMAXDialog show onClose={closeAboutRmaxDialog} />
        </Suspense>
      )}
    </>
  );
};

export default compose(withAppConfig, withStyles(styles))(HelpMenu);
